import { animateScroll as scroll } from 'react-scroll'
import { StyledScrollBtn } from '@/components/styles'
import { useEffect, useState } from 'react'
import Icon from '@/assets/icons'

export default function ScrollBtn() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY
      const windowHeight = window.innerHeight
      const documentHeight = document.body.offsetHeight

      const pageEnd = scrollPos + windowHeight >= documentHeight - 20
      const notPageEnd = scrollPos + windowHeight < documentHeight - 20
      const pageStart = scrollPos < 40

      if ((pageStart) && visible) {
        setVisible(false)
      }
      if (!pageStart && !visible) {
        setVisible(true)
      }
    }

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [visible])

  return (
    <StyledScrollBtn onClick={() => scroll.scrollToTop()} visible={visible}>
      <Icon name="up-icon" />
    </StyledScrollBtn>
  )
}
